import searchApiFactory from '../../modules/search/searchApi';

/* Actions */
import {
  getNextSearchProductsActionCreators,
  getSearchProductsActionCreators,
} from '../actions/searchActions';

/* Utils */
import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils';

function searchSagasFactory({storefrontApiClient}) {
  const productApi = searchApiFactory(storefrontApiClient);

  const getSearchProductsSaga = generateDefaultAsyncSaga(
    productApi.getSearchProducts,
    getSearchProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
      payload.headers,
    ]
  );

  const getNextSearchProductsSaga = generateDefaultAsyncSaga(
    productApi.getSearchProducts,
    getNextSearchProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
      payload.headers,
    ]
  );

  const watchGetSearchProducts = generateDefaultAsyncWatcher(
    'GET_SEARCH_PRODUCTS',
    getSearchProductsSaga
  );

  const watchGetNextSearchProducts = generateDefaultAsyncWatcher(
    'GET_NEXT_SEARCH_PRODUCTS',
    getNextSearchProductsSaga,
  );

  const searchSagas = [
    watchGetSearchProducts(),
    watchGetNextSearchProducts(),
  ];

  return searchSagas;
}

export default searchSagasFactory;
